import React from "react";
import "quill/dist/quill.snow.css";
import type { Quill } from "quill";

interface Props {
    initialValue?: string;
    onChange?: (value: string) => void;
    label?: string;
    disabled?: boolean;
}

export class EmailEditor extends React.Component<Props>
{
    private div = React.createRef<HTMLDivElement>();

    componentDidMount() {
        this.loadQuill();
    }

    private quill: Quill;
    private loadQuill = async () => {

        this.quill = new (await import("quill")).default(this.div.current!, {
            modules: { toolbar: true },
            theme: 'snow',
            readOnly: this.props.disabled,
        });

        this.quill.root.innerHTML = this.props.initialValue ?? "";
        this.quill.on("text-change", () => this.props.onChange?.(this.quill.root.innerHTML));
    }

    render() {
        return (
            <div>
                {this.props.label ? <label className="form-label">{this.props.label}</label> : <div />}
                <div ref={this.div} style={{ minHeight: 75 }}>
                </div>
            </div>
        );
    }
}